//#region src/utils/runtimeEnvironment.ts
const isDevelopmentEnvironment = () => {
	try {
		return process.env.NODE_ENV === "development";
	} catch {}
	return false;
};
const isTestEnvironment = () => {
	try {
		return process.env.NODE_ENV === "test";
	} catch {}
	return false;
};
const isProductionEnvironment = () => {
	try {
		return process.env.NODE_ENV === "production";
	} catch {}
	return false;
};

//#endregion
export { isDevelopmentEnvironment as isDevelopmentEnvironment$1, isProductionEnvironment as isProductionEnvironment$1, isTestEnvironment as isTestEnvironment$1 };
//# sourceMappingURL=runtimeEnvironment-aTp6aZUT.mjs.map